import React from "react";
import { useHistory, Route, Switch, Redirect } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { useSelector } from "react-redux";
import { connect } from 'react-redux';
import axios from 'axios';
// import routes from "SuperRoutes";
import Profile from "pages/common/Profile.js";
import Settings from "pages/common/Settings.js";
import ViewProfile from "pages/common/ViewProfile.js";
import ViewEvent from "pages/common/ViewEvent.js";
import Home from "pages/superadmin/Home.js";
import Messaging from "pages/superadmin/Messaging.js";
import PreEvents from "pages/superadmin/PreEvents.js";
import AddEvent from "pages/superadmin/AddEvent.js";
import AddPreEvent from "pages/superadmin/AddPreEvent.js";
import EditEvent from "pages/superadmin/EditEvent.js";
import AddPoster from "pages/superadmin/AddPoster.js";
import Events from "pages/superadmin/Events.js";
import FinEvents from "pages/superadmin/FinEvents.js";
import Message from "pages/superadmin/Message.js";
import PubEvents from "pages/superadmin/PubEvents.js";
import RegEvents from "pages/superadmin/RegEvents.js";
import Accounts from "pages/superadmin/Accounts.js";
import 'axios-progress-bar/dist/nprogress.css'


const Admin = (props) => {


    const user = useSelector(state => state.userName);
    // loadProgressBar()
    const usern2 = useSelector(state => state.switchRoutes.superadmin);
    const usern = useSelector(state => state.switchRoutes.admin);
    const [notifications, setnotifications] = React.useState([]);
    const history = useHistory();
    // console.log(user)
    // console.log(usern)
    var routes =[]
    if (user.length < 1) {
        history.push("/auth/login");
    }
    if (usern2 === true) {
        routes = [
            // working
            {
                path: "/home",
                name: "Dashboard",
                icon: "ni ni-tv-2 text-",
                component: Home,
                render: props => (
                    <Home {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/events",
                name: "Events",
                icon: "ni ni-single-copy-04 text-",
                component: Events,
                render: props => (
                    <Events {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/add-event",
                name: "Add Event",
                icon: "ni ni-fat-add text-",
                // component: AddEvent,
                render: props => (
                    <AddEvent {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            {
                path: "/pre-events",
                name: "Pre Events",
                icon: "ni ni-ungroup text-fdvd",
                component: PreEvents,
                render: props => (
                    <PreEvents {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            {
                path: "/add-pre-event",
                name: "Add Pre Event",
                icon: "ni ni-fat-add text-fdvd",
                component: AddPreEvent,
                render: props => (
                    <AddPreEvent {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            // {
            //     path: "/edit-event",
            //     name: "Edit Event",
            //     icon: "ni ni-fat-add text-",
            //     component: EditEvent,
            //     render: props => (
            //         <EditEvent {...props} fetch={fetchData} />
            //     ),
            //     layout: "/main",
            // },
            // working
            {
                path: "/edit/:id",
                name: "Edit Event",
                icon: "ni ni-fat-add text-",
                component: EditEvent,
                render: props => (
                    <EditEvent {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/add-poster",
                name: "Add Poster",
                icon: "ni ni-fat-add text-",
                component: AddPoster,
                render: props => (
                    <AddPoster {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/accounts",
                name: "Accounts",
                icon: "ni ni-circle-08 text-",
                component: Accounts,
                render: props => (
                    <Accounts {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/messaging",
                name: "Messaging",
                icon: "ni ni-email-83 text-",
                component: Messaging,
                render: props => (
                    <Messaging {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/published-events",
                name: "Published Events",
                icon: "ni ni-book-bookmark text-",
                component: PubEvents,
                render: props => (
                    <PubEvents {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/finished-events",
                name: "Finished Events",
                icon: "ni ni-time-alarm text-",
                component: FinEvents,
                render: props => (
                    <FinEvents {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/message/:id",
                name: "Messaging",
                icon: "ni ni-time-alarm text-",
                component: Message,
                render: props => (
                    <Message {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            {
                path: "/settings",
                name: "Settings",
                icon: "ni ni-bullet-list-67 text-",
                component: Settings,
                render: props => (
                    <Settings {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // working
            {
                path: "/user-profile",
                name: "User Profile",
                icon: "ni ni-single-02 text-yellow",
                component: Profile,
                render: props => (
                    <Profile {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            {
                path: "/profile/:id",
                name: "Profile",
                icon: "ni ni-single-02 text-yellow",
                component: ViewProfile,
                render: props => (
                    <ViewProfile {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            {
                path: "/event/:id",
                name: "View Event Ha",
                icon: "ni ni-single-02 text-yellow",
                component: ViewEvent,
                render: props => (
                    <ViewEvent {...props} fetch={fetchData} />
                ),
                layout: "/main",
            },
            // {
            //     path: "/preevent/:id",
            //     name: "View Pre Event Ha",
            //     icon: "ni ni-single-02 text-yellow",
            //     component: ViewPreEvent,
            //     render: props => (
            //         <ViewPreEvent {...props} fetch={fetchData} />
            //     ),
            //     layout: "/main",
            // },
        ];
    }
    else{
        if (usern === true) {
            routes = [
                // working
                {
                    path: "/home",
                    name: "Dashboard",
                    icon: "ni ni-tv-2 text-",
                    component: Home,
                    render: props => (
                        <Home {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/events",
                    name: "Events",
                    icon: "ni ni-single-copy-04 text-",
                    component: Events,
                    render: props => (
                        <Events {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/add-event",
                    name: "Add Event",
                    icon: "ni ni-fat-add text-",
                    // component: AddEvent,
                    render: props => (
                        <AddEvent {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/pre-events",
                    name: "Pre Events",
                    icon: "ni ni-ungroup text-fdvd",
                    component: PreEvents,
                    render: props => (
                        <PreEvents {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/add-pre-event",
                    name: "Add Pre Event",
                    icon: "ni ni-fat-add text-fdvd",
                    component: AddPreEvent,
                    render: props => (
                        <AddPreEvent {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                // {
                //     path: "/edit-event",
                //     name: "Edit Event",
                //     icon: "ni ni-fat-add text-",
                //     component: EditEvent,
                //     render: props => (
                //         <EditEvent {...props} fetch={fetchData} />
                //     ),
                //     layout: "/main",
                // },
                // working
                {
                    path: "/edit/:id",
                    name: "Edit Event",
                    icon: "ni ni-fat-add text-",
                    component: EditEvent,
                    render: props => (
                        <EditEvent {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/add-poster",
                    name: "Add Poster",
                    icon: "ni ni-fat-add text-",
                    component: AddPoster,
                    render: props => (
                        <AddPoster {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                // {
                //     path: "/accounts",
                //     name: "Accounts",
                //     icon: "ni ni-circle-08 text-",
                //     component: Accounts,
                //     render: props => (
                //         <Accounts {...props} fetch={fetchData} />
                //     ),
                //     layout: "/main",
                // },
                // working
                {
                    path: "/messaging",
                    name: "Messaging",
                    icon: "ni ni-email-83 text-",
                    component: Messaging,
                    render: props => (
                        <Messaging {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/published-events",
                    name: "Published Events",
                    icon: "ni ni-book-bookmark text-",
                    component: PubEvents,
                    render: props => (
                        <PubEvents {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/finished-events",
                    name: "Finished Events",
                    icon: "ni ni-time-alarm text-",
                    component: FinEvents,
                    render: props => (
                        <FinEvents {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/message/:id",
                    name: "Messaging",
                    icon: "ni ni-time-alarm text-",
                    component: Message,
                    render: props => (
                        <Message {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/settings",
                    name: "Settings",
                    icon: "ni ni-bullet-list-67 text-",
                    component: Settings,
                    render: props => (
                        <Settings {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/user-profile",
                    name: "User Profile",
                    icon: "ni ni-single-02 text-yellow",
                    component: Profile,
                    render: props => (
                        <Profile {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/profile/:id",
                    name: "Profile",
                    icon: "ni ni-single-02 text-yellow",
                    component: ViewProfile,
                    render: props => (
                        <ViewProfile {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/event/:id",
                    name: "View Event Ha",
                    icon: "ni ni-single-02 text-yellow",
                    component: ViewEvent,
                    render: props => (
                        <ViewEvent {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // {
                //     path: "/preevent/:id",
                //     name: "View Pre Event Ha",
                //     icon: "ni ni-single-02 text-yellow",
                //     component: ViewPreEvent,
                //     render: props => (
                //         <ViewPreEvent {...props} fetch={fetchData} />
                //     ),
                //     layout: "/main",
                // },
            ];
        }
        else {
            routes = [
                // working
                // {
                //     path: "/home",
                //     name: "Dashboard",
                //     icon: "ni ni-tv-2 text-",
                //     component: Home,
                //     render: props => (
                //         <Home {...props} fetch={fetchData} />
                //     ),
                //     layout: "/main",
                // },
                // working
                {
                    path: "/home",
                    name: "Events",
                    icon: "ni ni-single-copy-04 text-",
                    component: Events,
                    render: props => (
                        <Events {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/add-poster",
                    name: "Add Poster",
                    icon: "ni ni-fat-add text-",
                    component: AddPoster,
                    render: props => (
                        <AddPoster {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/messaging",
                    name: "Messaging",
                    icon: "ni ni-email-83 text-",
                    component: Messaging,
                    render: props => (
                        <Messaging {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/registered-events",
                    name: "Registered Events",
                    icon: "ni ni-time-alarm text-",
                    component: RegEvents,
                    render: props => (
                        <RegEvents {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/message/:id",
                    name: "Messaging",
                    icon: "ni ni-time-alarm text-",
                    component: Message,
                    render: props => (
                        <Message {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/settings",
                    name: "Settings",
                    icon: "ni ni-bullet-list-67 text-",
                    component: Settings,
                    render: props => (
                        <Settings {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // working
                {
                    path: "/user-profile",
                    name: "User Profile",
                    icon: "ni ni-single-02 text-yellow",
                    component: Profile,
                    render: props => (
                        <Profile {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/profile/:id",
                    name: "Profile",
                    icon: "ni ni-single-02 text-yellow",
                    component: ViewProfile,
                    render: props => (
                        <ViewProfile {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                {
                    path: "/event/:id",
                    name: "View Event Ha",
                    icon: "ni ni-single-02 text-yellow",
                    component: ViewEvent,
                    render: props => (
                        <ViewEvent {...props} fetch={fetchData} />
                    ),
                    layout: "/main",
                },
                // {
                //     path: "/preevent/:id",
                //     name: "View Pre Event Ha",
                //     icon: "ni ni-single-02 text-yellow",
                //     component: ViewPreEvent,
                //     render: props => (
                //         <ViewPreEvent {...props} fetch={fetchData} />
                //     ),
                //     layout: "/main",
                // },
            ];
        } 
    }
    
    const mainContent = React.useRef(null);
    // const location = useLocation();

    const fetchData = React.useCallback(() => {
        // console.log('entered HHHHHHHHHHHHHHHHHHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA')
        axios.get(process.env.REACT_APP_DOMAIN + "/getnotifications", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setnotifications(response.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [props.token])

    setTimeout(() => {
        // fetchData()
        // console.log('to fetch')
    }, 2000);
    const clearNoti = () => {
        setnotifications([])
    }
    React.useEffect(() => {
        fetchData()
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainContent.current.scrollTop = 0;
    }, [fetchData])

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/main") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        render={prop.render}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    const getBrandText = (path) => {
        for (let i = 0; i < routes.length; i++) {
            if (
                props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
                -1
            ) {
                return routes[i].name;
            }
        }
        return "View";
    };

    return (
        <>
            <Sidebar
                {...props}
                routes={routes}
                noti={notifications}
                fetch={fetchData}
                clear={clearNoti}
                logo={{
                    innerLink: "/main/home",
                    imgSrc: require("../assets/img/kjm.png").default,
                    imgAlt: "...",
                }}
            />
            <div className={"main-content lbg-" + props.theme} ref={mainContent}>
                <AdminNavbar
                    {...props}
                    noti={notifications}
                    fetch={fetchData}
                    clear={clearNoti}
                    brandText={getBrandText(props.location.pathname)}
                />
                <Switch>
                    {getRoutes(routes)}
                    <Redirect from="/main" to="/main/home" />
                </Switch>
                <Container fluid>
                    <AdminFooter />
                </Container>
            </div>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Admin);
